/*!

=========================================================
* Argon Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

import Dashboard from "views/pages/dashboards/Dashboard.js";
import Login from "views/pages/examples/Login.js";

// My Imports
import ListUsers from "views/pages/manageUsers/list";
import ListPermissions from "views/pages/managePermissions";
import ListStatus from "views/pages/manageStatus";
import HistoryPage from "views/pages/history";
import Duelist from "views/pages/uploadData/duelist";
import UserDashboard from "views/pages/dashboards/UserDashboard.jsx";
import ManagerDashboard from "views/pages/dashboards/ManagerDashboard";

import CardsHeader from "components/Headers/CardsHeader";
import ImportRPA from "views/pages/rpaImport";

const routes = [
  {
    collapse: false,
    name: "Inicio",
    icon: "ni ni-single-copy-04",
    state: "listDuelist",
    path: "/home",
    component: Duelist,
    layout: "/admin",
  },
  {
    collapse: false,
    name: "Atribuição",
    icon: "ni ni-bell-55",
    state: "userDashboardState",
    path: "/user-dashboard",
    component: UserDashboard,
    layout: "/admin",
  },
  {
    collapse: false,
    name: "Painel Gerencial",
    icon: "ni ni-chart-bar-32",
    state: "managerDashboardState",
    path: "/manager-dashboard",
    component: ManagerDashboard,
    layout: "/admin",
    adminOnly: true,
  },
  {
    collapse: false,
    icon: "ni ni-chart-bar-32",
    state: "dashboardItem",
    path: "/dashboard",
    name: "Dashboard",
    miniName: "D",
    component: Dashboard,
    layout: "/admin",
    invisible: true,
  },
  {
    collapse: false,
    name: "Permissões",
    icon: "ni ni-key-25",
    state: "PermissionsCollapse",
    path: "/permissions",
    component: ListPermissions,
    layout: "/admin",
    invisible: true,
  },
  {
    collapse: true,
    name: "Examples",
    icon: "ni ni-ungroup",
    state: "examplesCollapse",
    invisible: true,
    views: [
      {
        path: "/login",
        name: "Login",
        miniName: "L",
        component: Login,
        layout: "/auth",
      },
    ],
  },
  {
    collapse: true,
    name: "Administração",
    icon: "ni ni-folder-17",
    state: "statusOption",
    invisible: false,
    views: [
      {
        path: "/status",
        miniName: "STATS",
        icon: "ni ni-check-bold",
        component: ListStatus,
        layout: "/admin",
        name: "Lista de Status",
      },
      {
        collapse: false,
        name: "Usuarios",
        icon: "ni ni-circle-08",
        state: "UsersCollapse",
        path: "/users",
        miniName: "U",
        component: ListUsers,
        layout: "/admin",
      },
      {
        collapse: false,
        name: "Status dos Processos",
        icon: "ni ni-credit-card",
        state: "CardsCollapse",
        path: "/cards",
        miniName: "C",
        component: CardsHeader,
        layout: "/admin",
        // collapse: false,
        // name: "Cards",
        // icon: "ni ni-credit-card text-blue",
        // state: "CardsCollapse",
        // path: "/cards",
        // miniName: "C",
        // component: CardsHeader, // Using CardsHeader as the component
        // layout: "/admin",
      },
    ],
  },
  {
    collapse: false,
    name: "Histórico",
    icon: "ni ni-books",
    state: "historicOption",
    path: "/historic",
    miniName: "HS",
    component: HistoryPage,
    layout: "/admin",
    invisible: true,
  },
  {
    collapse: false,
    name: "Importação Precatórios",
    icon: "ni ni-cloud-upload-96",
    state: "rpaImport",
    path: "/rpa-import",
    component: ImportRPA,
    layout: "/admin",
    adminOnly: true,
  },
];

export default routes;
